export default "__VITE_PUBLIC_ASSET__22523d9c__"